import type { AdDevice, AdStatus, AdType, BannerAd, PromptAd } from '../types/ad'
import { APIFetch, filterResponse } from '.'

export const getAd = async (queries: {
  not_id?: number[]
  device?: AdDevice
  type: AdType
}): Promise<null | BannerAd | PromptAd> => {
  const BASE_URL = useRuntimeConfig().public.commentsApiUrl
  let url = '/sponsors'
  url = useParseQuery(url, queries)

  return filterResponse(await APIFetch(url, {
    method: 'GET',
    baseUrl: BASE_URL,
  }))
}

export const getSponsorLink = (id: number) => {
  return `${useRuntimeConfig().public.commentsApiUrl}/sponsors/${id}`
}

export const getAdStatus = async () => {
  const BASE_URL = useRuntimeConfig().public.commentsApiUrl
  const path = '/sponsors-status'
  return filterResponse<AdStatus>(await APIFetch(path, {
    method: 'GET',
    baseUrl: BASE_URL,
  }))
}
